import { render } from "./EmployeeAccessWarehouse.vue?vue&type=template&id=4f32dc67&scoped=true"
import script from "./EmployeeAccessWarehouse.vue?vue&type=script&lang=js"
export * from "./EmployeeAccessWarehouse.vue?vue&type=script&lang=js"

import "./EmployeeAccessWarehouse.vue?vue&type=style&index=0&id=4f32dc67&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f32dc67"],['__file',"src/views/h5/common/basedata/employee/employeeDataAccess/EmployeeAccessWarehouse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f32dc67"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f32dc67', __exports__)) {
    api.reload('4f32dc67', __exports__)
  }
  
  module.hot.accept("./EmployeeAccessWarehouse.vue?vue&type=template&id=4f32dc67&scoped=true", () => {
    api.rerender('4f32dc67', render)
  })

}


export default __exports__